import styles from "./Player.module.css";
import { FaSignal } from "react-icons/fa";
import PlayerAvatarV2 from "./PlayerAvatarV2";
import { useGameTime } from "@/src/ducks/gameTime";
import TimeV2 from "./TimeV2";

function renderElo(elo: number, previousElo: number) {
  if (previousElo) {
    const diff = elo - previousElo;
    let diffTag;

    if (diff > 0) {
      diffTag = <span className={styles.diffEqual}>+{diff}</span>;
    } else if (diff < 0) {
      diffTag = <span className={styles.diffEqual}>{diff}</span>;
    } else {
      diffTag = <span className={styles.diffEqual}>0</span>;
    }
    return (
      <>
        {elo} ({diffTag})
      </>
    );
  } else {
    return elo;
  }
}

function renderDesktopElo(elo: number, previousElo: number) {
  if (previousElo) {
    const diff = elo - previousElo;
    let diffTag;

    if (diff > 0) {
      diffTag = <span className={styles.diffEqual}>+{diff}</span>;
    } else if (diff < 0) {
      diffTag = <span className={styles.diffEqual}>{diff}</span>;
    } else {
      diffTag = <span className={styles.diffEqual}>0</span>;
    }

    return (
      <div className="inline-flex">
        <div className="pr-1 text-base">
          <FaSignal />
        </div>
        {elo} ({diffTag})
      </div>
    );
  } else {
    return (
      <div className="inline-flex">
        <div className="pr-1 text-base">
          <FaSignal />
        </div>
        {elo}
      </div>
    );
  }
}

function Player({
  elo,
  previousElo,
  displayName,
  gameEnded,
  avatarId,
  fbId,
  isUser,
  isGuest,
  id,
  avatarType,
  turn,
}) {
  const { userTime, opponentTime } = useGameTime();

  const usernameStyle = gameEnded ? styles.usernameGameEnded : styles.username;

  return (
    <div key={isUser ? "user" : "opponent"} className={`${styles.playerV2} `}>
      <div className={styles.headerV2}>
        <div className={usernameStyle}>{displayName}</div>
        {renderDesktopElo(elo, previousElo)}
      </div>
      <div className={styles.bodyV2}>
        <div className="flex justify-center gap-2 ">
          <PlayerAvatarV2
            {...{ isUser, avatarId, fbId, isGuest, id, avatarType, gameEnded }}
          />
          <div className="flex flex-col flex-1 flex-shrink min-w-0 md:hidden">
            <div className={`text-sm font-semibold truncate text-ellipsis`}>
              {displayName}
            </div>
            <div className="flex items-center text-xs gap-0.5">
              {renderElo(elo, previousElo)}
            </div>
          </div>
        </div>

        {isUser ? (
          <div className={styles.timeContainer}>
            <TimeV2 time={userTime} isRunning={turn} />
          </div>
        ) : (
          <div className={styles.timeContainer}>
            <TimeV2 time={opponentTime} isRunning={turn} />
          </div>
        )}
      </div>
    </div>
  );
}

export default Player;
